import React from "react";
import GenericTable from "./GenericTable";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { IconButton, Tooltip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const AutomationRuleTable = ({
  automationRules = [],
  rowCount,
  pageSize,
  page,
  onPageChange,
  onPageSizeChange,
  onSearch,
  onEditRule,
  onDeleteRule,
  onDeleteSelected,
  isLoading,
}) => {
  const { t } = useTranslation("settings");
  const rows = automationRules.map((rule) => ({
    id: rule.id,
    descricao: rule.descricao || t("shared.notApplicable"),
    _raw: rule,
  }));

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "descricao", headerName: t("automationRuleTable.colDescription"), width: 300 },
    {
      field: "actions",
      headerName: t("shared.actions"),
      width: 250,
      renderCell: (params) => (
        <Box display="flex" gap={1}>
          <Tooltip title={t("shared.edit")}>
            <IconButton
              size="small"
              onClick={() => onEditRule?.(params.row._raw)}
            >
              <EditRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("shared.delete")}>
            <IconButton
              size="small"
              onClick={() => onDeleteRule?.(params.row.id)}
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <GenericTable
      rows={rows}
      columns={columns}
      rowCount={rowCount}
      pageSize={pageSize}
      page={page}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      onSearch={onSearch}
      isLoading={isLoading}
      onExportPDFTitle={t("automationRuleTable.exportTitle")}
      exportFileName="regras_automacao"
      onDeleteSelected={onDeleteSelected}
    />
  );
};

export default AutomationRuleTable;
